import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

// URL base de la API
const API_URL = getApiBaseUrl();
// const API_URL = getApiBaseUrl();

//// Crear una instancia de Axios
const api = axios.create({
  baseURL: API_URL,
});

// Configurar un interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
  (config) => {
    // Obtener el token del localStorage
    const token = secureStorage.getItem('authToken');
    
    if (token) {
      // Agregar el token al encabezado de autorización
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);


const getDatosVehiculo = async (codigo) => {
  try {
    const response = await api.get('truck',{ params: { codigo } });
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getDatos= async () => {
  try {
    const response = await api.get('truck');
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getOneDatos = async (id) => {
  try {
    const response = await api.get(`truck/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getDinatran = async (chapa, country) => {
  try {
    const response = await api.get('web', {
      params: { plate: chapa, country },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.message;
    throw new Error('Error al obtener datos del backend: ' + errorMessage);
  }
};

const getTruckImagen = async (codigoTaller, anoItv, certificado) => {
  try {
    const response = await api.get('webscp/inspection', {
      params: { codigoTaller, anoItv, certificado },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.message;
    throw new Error('Error al obtener datos del backend: ' + errorMessage);
  }
};


const PostDatosVehiculo = async (datos) => {
  try {
    const response = await api.post('truck', datos);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const updateDatosVehiculo = async (id, datos) => {
  try {
    const response = await api.put(`truck/${id}`, datos);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error('Error al actualizar datos del backend: ' + error.response.data.message);
    }
    throw new Error('Error al actualizar datos del backend: ' + error.message);
  }
};

export { getDatosVehiculo, getOneDatos, getDatos, PostDatosVehiculo, updateDatosVehiculo, getDinatran, getTruckImagen };
